module.exports = __webpack_public_path__ + "static/media/section1_bubble.6dbb3e0b.svg";